import { siteText } from '../siteText'
import { formatClipTitle } from '../titleLines'

export function TitleText({ children }: { children: string }) {
  return <span className="title-text">{siteText(formatClipTitle(children))}</span>
}
